import React from 'react'
import { useForm, UseFormReturn } from 'react-hook-form'
const {
  constants: { SUPPORTED_WIRE_COUNTRIES },
} = require('@plastiq/external-api-validation')
import {
  COUNTRIES,
  CountryObject,
  countriesSx,
} from '../../../../utils/countries'

// TODO see if we can leverage a path alias for the base directory or root/src
import Dropdown, { ItemObject } from '../../../../base/Dropdown/Dropdown'
import TextInput from '../../../../base/TextInput/TextInput'
import { inputProperties } from '../../../../types/inputProperties'
import { validators } from '../../../../utils/validators'
import InputGroup from '../../../../base/InputGroup/InputGroup'

export interface WireDeliveryMethodProps {
  accountNumber?: inputProperties
  country?: inputProperties
  beneficiaryName?: inputProperties
  form?: UseFormReturn
  instructionLabel?: string
  routingNumber?: inputProperties
}

const WireDeliveryMethod = (props: WireDeliveryMethodProps) => {
  const useFormDefault = props.form || useForm()
  useFormDefault.setValue('type', 'WIRE')

  Object.assign(
    WireDeliveryMethod.defaultProps.beneficiaryName,
    props.beneficiaryName,
  )
  Object.assign(WireDeliveryMethod.defaultProps.country, props.country)
  Object.assign(
    WireDeliveryMethod.defaultProps.accountNumber,
    props.accountNumber,
  )
  Object.assign(
    WireDeliveryMethod.defaultProps.routingNumber,
    props.routingNumber,
  )

  //List of wire supported countries ['US', 'CA', etc]
  const supportedWireCountriesAbbreviation: Array<string> =
    SUPPORTED_WIRE_COUNTRIES.map(
      (country: { abbreviation: string }) => country?.abbreviation,
    )

  //Wire countries in format ItemObject
  const menuItems: Array<ItemObject> = COUNTRIES.filter(item =>
    supportedWireCountriesAbbreviation.includes(item.abbreviation),
  ).map((item: CountryObject) => ({
    value: item.abbreviation,
    label: item.name,
    className: `flag flagSpacing ${item.abbreviation}`,
  }))

  return (
    <InputGroup
      inputRows={[
        [
          <Dropdown
            form={useFormDefault}
            items={menuItems}
            menuProps={{ sx: { ...countriesSx } }}
            sx={countriesSx}
            {...WireDeliveryMethod.defaultProps.country}
          />,
        ],
        [
          <TextInput
            form={useFormDefault}
            rules={{ validate: validators.beneficiaryName }}
            {...WireDeliveryMethod.defaultProps.beneficiaryName}
          />,
        ],
        [
          <TextInput
            form={useFormDefault}
            rules={{ validate: validators.WireRoutingNumber }}
            {...WireDeliveryMethod.defaultProps.routingNumber}
          />,
        ],
        [
          <TextInput
            form={useFormDefault}
            rules={{ validate: validators.accountNumber }}
            {...WireDeliveryMethod.defaultProps.accountNumber}
          />,
        ],
      ]}
    />
  )
}

WireDeliveryMethod.defaultProps = {
  accountNumber: {
    label: 'Bank Account Number',
    name: 'accountNumber',
    required: true,
  },
  beneficiaryName: {
    label: 'Name on Account',
    name: 'beneficiaryName',
    required: true,
  },
  country: {
    label: 'Select a country',
    name: 'country',
    required: true,
    value: 'US',
  },
  type: {
    label: 'Delivery Type',
    name: 'type',
    required: true,
  },
  instructionLabel:
    'Send wire payment to the bank account by next business day. Fees apply.',
  routingNumber: {
    label: 'Wire Routing Number',
    name: 'routingNumber',
    required: true,
  },
}

export default WireDeliveryMethod
